<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-xl-6 col-lg-6 col-md-6">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
          <span class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{tablePageData.length}} resultados
          </span>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 text-right">
          <a href="#!" class="btn btn-primary" @click="createCustomer">Agregar cliente</a>
        </div>
      </div>
    </div>
    <base-input style="padding-left: 2rem; padding-right: 2rem" placeholder="Buscar" v-model="search"> </base-input>
    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tablePageData">
        <template slot="columns">
          <th>ID Cliente</th>
          <th>R. Social</th>
          <th>Permiso</th>
          <th>Ubicación</th>
          <th>Creado el</th>
          <th></th>
        </template>

        <template slot-scope="{row}">
          <th>
           {{row.clientId}}
          </th>
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{truncateText(row.razonSocial)}}</span>
              </div>
            </div>
          </th>
          <td class="align-items-center">
            {{row.numCRE}}
          </td>
          <td>
            {{row.ciudad}}, {{row.estado}}
          </td>
          <td class="align-items-center">
            {{getReadableDate(row.createdOn)}}
          </td>
          <td class="text-right">
            <base-dropdown 
              class="dropdown"
              position="right">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>
              <template>
                <a class="dropdown-item" @click="goToRowDetails(row)">Ver más</a>
              </template>
            </base-dropdown>
          </td>
        </template>
      </base-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import router from '../../router';
export default {
    name: 'clients-table',
    props: {
      type: {
        type: String
      },
      title: String,
      tableData: Array
    },
    computed: {
      tablePageData: function () {
        let search = this.search.toUpperCase();
        return this.tableData.filter((item) => {
          let containsClientId = item.clientId.toUpperCase().includes(search);
          let containsRazonSocial = item.razonSocial.toUpperCase().includes(search);
          let containsCREid = item.numCRE.toUpperCase().includes(search);
          let estado = item.estado.toUpperCase().includes(search);
          let ciudad = item.ciudad.toUpperCase().includes(search);
          return containsClientId || containsRazonSocial || containsCREid || estado || ciudad;
        })
      }
    },
    methods:{
      goToRowDetails(row){
        this.$emit('get-details', row);
      },
      getReadableDate(timestamp){
        moment.locale('es');
        let time = moment(timestamp, 'x')
        return time.format('ll');
      },
      truncateText(text){
        if(text.length > 20){
          return text.substring(0, 25) + '...';
        } 
        return text;
      },
      createCustomer(){
        router.replace('/create');
      }
    },
    data() {
      return {
        search: ''
      }
    }
  }
</script>
<style>
</style>